// extracted by mini-css-extract-plugin
module.exports = {"tickets-button":"ticket-notifications_tickets-button__ZK2hI"};